import React, {useEffect, useState} from 'react';
import {NODE_API} from 'constants/index';
import {useLocation} from 'react-router-dom';

export function FarmerAcceptInvitation() {
  const {search} = useLocation();
  const searchParams = new URLSearchParams(search);
  const invitationCode = searchParams.get('invitation-code');

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [isSuccess, setIsSuccess] = useState(false);

  useEffect(() => {
    if (!invitationCode) return;

    setLoading(true);
    setError(null);
    setIsSuccess(false);

    fetch(
      `${NODE_API}/farmer-accept-invitation?invitationCode=${encodeURIComponent(
        invitationCode,
      )}`,
    )
      .then(async (res) => {
        if (!res.ok)
          throw new Error(
            'Failed to accept invitation. Please try again later.',
          );
        return res.text();
      })
      .then(() => {
        setIsSuccess(true);
      })
      .catch(() => {
        setError('Something went wrong. Please try again later.');
      })
      .finally(() => setLoading(false));
  }, [invitationCode]);

  if (!invitationCode) return <div>Error: Invitation code is missing.</div>;
  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;
  if (isSuccess) return <div>Successfully accepted invitation.</div>;

  return null;
}
